/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PluginType } from './PluginType';
import {
    PluginTypeFromJSON,
    PluginTypeFromJSONTyped,
    PluginTypeToJSON,
} from './PluginType';

/**
 * 
 * @export
 * @interface PluginDefinitionResponse
 */
export interface PluginDefinitionResponse {
    /**
     * 
     * @type {string}
     * @memberof PluginDefinitionResponse
     */
    description?: string;
    /**
     * 
     * @type {PluginType}
     * @memberof PluginDefinitionResponse
     */
    type: PluginType;
    /**
     * 
     * @type {string}
     * @memberof PluginDefinitionResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PluginDefinitionResponse
     */
    id: string;
}



/**
 * Check if a given object implements the PluginDefinitionResponse interface.
 */
export function instanceOfPluginDefinitionResponse(value: object): value is PluginDefinitionResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PluginDefinitionResponseFromJSON(json: any): PluginDefinitionResponse {
    return PluginDefinitionResponseFromJSONTyped(json, false);
}

export function PluginDefinitionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PluginDefinitionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'type': PluginTypeFromJSON(json['type']),
        'name': json['name'],
        'id': json['id'],
    };
}

export function PluginDefinitionResponseToJSON(value?: PluginDefinitionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'type': PluginTypeToJSON(value['type']),
        'name': value['name'],
        'id': value['id'],
    };
}

